import { LOGIN_OTP, LOGOUT, LOGIN_DATA } from "./type";

const initialState = {
  otp: null,
  login_data: [],
};

const loginOtp = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_OTP:
      return {
        ...state,
        otp: payload,
      };
      case LOGIN_DATA:
      return {
        ...state,
        login_data: payload,
      };
    case LOGOUT:
      return {
        otp: payload,
      };
    default:
      return { ...state };
  }
};

export default loginOtp;
